//Use this for showing date on UI

const convertDateToLocal = (dateInput, dateFormat) => {
  if (dateInput == null) return "invalid date";

  let dateValue = new Date(dateInput + "Z").toLocaleDateString("hi-IN"); //.toLocaleString('hi-IN');
  let DateArray = dateValue.split("/");

  let day = DateArray[0]?.padStart(2, "0");
  let month = DateArray[1]?.padStart(2, "0");
  let year = DateArray[2];

  // let day = dateValue.getDate().toString().padStart(2, '0');
  // let month = (dateValue.getMonth() + 1).toString().padStart(2, '0');
  // let year = dateValue.getFullYear();

  if (dateFormat === "dd-MM-yyyy") {
    return `${day}-${month}-${year}`;
  } else if (dateFormat === "MM-dd-yyyy") {
    return `${month}-${day}-${year}`;
  } else if (dateFormat === "yyyy-MM-dd") {
    return `${year}-${month}-${day}`;
  } else {
    return `${day}-${month}-${year}`;
  }

  // Default to 'yyyy-mm-dd' if dateFormat is not recognized
  // return `${year}-${month}-${day}`;
};

//Use this for showing date in textfield on UI (use this for forms add & edit)
const convertDateToLocalReverse = (dateInput) => {
  let dateValue = new Date(dateInput); //.toLocaleString('hi-IN');
  let day = dateValue.getDate().toString()?.padStart(2, "0");
  let month = (dateValue.getMonth() + 1).toString()?.padStart(2, "0");
  let year = dateValue.getFullYear();
  return `${year}-${month}-${day}`;
};

const getDateDifference = (date1, date2) => {
  let date_1 = new Date(date1);
  let date_2 = new Date(date2);
  let diffTime = date_1 - date_2;
  let diff = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) - 1;
  return diff;
};

// const addDays = (date, days) => {
//   var date = new Date(date);
//   date.setDate(date.getDate() + days);
//   return date;
// };

export { convertDateToLocal, convertDateToLocalReverse, getDateDifference };
